import React from 'react';
import { useTheme } from '../../context/ThemeContext';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  color
}) => {
  const { isDarkMode } = useTheme();

  const getSize = () => {
    switch (size) {
      case 'small':
        return 'w-4 h-4';
      case 'large':
        return 'w-12 h-12';
      case 'medium':
      default:
        return 'w-8 h-8';
    }
  };

  // Determine spinner color based on props, dark mode, or default
  const getSpinnerColor = () => {
    if (color) {
      return color;
    }
    return isDarkMode ? '#818cf8' : '#4f46e5'; // indigo-400 : indigo-600
  };

  const spinnerColor = getSpinnerColor();

  return (
    <div className="flex justify-center items-center p-4">
      <div
        className={`${getSize()} border-4 border-t-transparent border-solid rounded-full animate-spin`}
        style={{ borderColor: `transparent ${spinnerColor} ${spinnerColor} ${spinnerColor}` }}
        role="status"
        aria-label="loading"
      />
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LoadingSpinner;
